var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRevertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7H13.5V11.25L15.6012 12.4987C15.1081 12.714 14.6496 12.9937 14.2362 13.3271L12 12V7ZM12.0004 17.9284C10.4698 17.7074 9.09848 16.9867 8.06 15.94L6.64 17.36C8.12357 18.8527 10.1042 19.8152 12.333 19.976C12.1173 19.3573 12 18.6923 12 18C12 17.9761 12.0001 17.9523 12.0004 17.9284ZM21.7061 13.2811C21.8997 12.5427 22 11.7765 22 11C22 8.61305 21.0518 6.32387 19.364 4.63604C17.6761 2.94821 15.3869 2 13 2C10.6131 2 8.32387 2.94821 6.63604 4.63604C4.94821 6.32387 4 8.61305 4 11H1L4.96 15.03L9 11H6C6 9.14348 6.7375 7.36301 8.05025 6.05025C9.36301 4.7375 11.1435 4 13 4C14.8565 4 16.637 4.7375 17.9497 6.05025C19.2625 7.36301 20 9.14348 20 11C20 11.4393 19.9587 11.8743 19.8783 12.2999C20.5473 12.5202 21.1643 12.855 21.7061 13.2811Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.15 14.5L21.57 15.92L19.44 18.04L21.57 20.16L20.15 21.58L18.03 19.45L15.91 21.58L14.5 20.16L16.62 18.04L14.5 15.92L15.91 14.51L18.03 16.63L20.15 14.5Z",
    fill: "#B00020"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevertIcon);
export default __webpack_public_path__ + "static/media/revertIcon.88a5f5bda0e20f1452352782c5c2c288.svg";
export { ForwardRef as ReactComponent };